import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaSalesLeadFileUploadHdrContainerModel } from "../../../../../../models/aggregates/sfa/salesLead/SfaSalesLeadFileUploadHdrContainer.model";
import { ApiVisa } from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaSalesLeadFileUploadHdrService extends BaseApiTemplateService<SfaSalesLeadFileUploadHdrContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"sales-lead-file-uploads";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"sales-lead-file-uploads";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"sales-lead-file-uploads";
		this.httpClient = http;
	}
	public upload(formData: FormData, type: string, visa: ApiVisa) {
		let url = visa.api_domain_url + this.endpoint_path;

		if (this.endpoint_path && visa.api_domain_url) {
			url = url + "/" + type;
		}
		return this.httpClient.post(url, formData, this.getHttpHeader(visa));
	}
}
